import { OESTRA_QUIZ_ENTRY_HREF } from "~/constants/oestraLandingPages";
import InstagramIcon from "@/icons/social/instagram.svg";
import FaceBookIcon from "@/icons/social/facebook.svg";
import YouTubeIcon from "@/icons/social/youtube.svg";
import TikTokIcon from "@/icons/social/tiktok.svg";

import { openChat } from "~/lib/intercom/IntercomScript";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { APP_ROUTES } from "~/constants/appRoutes";

export const footerMenus = [
    [
        {
            text: "Getting Started",
            items: [
                { href: OESTRA_QUIZ_ENTRY_HREF, text: "Take our health quiz" },
                { href: QUIZ_ROUTES.ANTI_AGING_FACE_CREAM, text: "Take our skin care quiz" },
            ],
            followUs: true,
        },
    ],
    [
        {
            text: "Learn",
            items: [
                { href: "/p/faq", text: "FAQs" },
                { href: "/about-us", text: "About us" },
                { href: "/science", text: "The Science" },
                { href: "/reviews", text: "Reviews" },
                { href: "/p/learn", text: "Journal" },
                { href: "/p/podcasts", text: "Featured In" },
            ],
        },
    ],
    [
        {
            text: "What We Treat",
            items: [
                { href: APP_ROUTES.TREATMENT_HRT, text: "General HRT" },
                { href: APP_ROUTES.TREATMENT_PERIMENOPAUSE, text: "Perimenopause" },
                { href: APP_ROUTES.TREATMENT_MENOPAUSE, text: "Menopause" },
                { href: "/treatment/endometriosis", text: "Endometriosis" },
                { href: APP_ROUTES.TREATMENT_PCOS, text: "PMOS/PCOS" },
                { href: APP_ROUTES.TREATMENT_POSTPARTUM, text: "Postpartum" },
                { href: APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM, text: "Skin Care" },
            ],
        },
    ],
    [
        {
            text: "Support",
            items: [
                { href: APP_ROUTES.SIGN_IN, text: "My account" },
                { href: "#", text: "Contact us", handleClick: openChat, preventDefault: true },
                { href: "/p/refund-policy", text: "Money back guarantee" },
            ],
            support: true
        },
        {
            text: "For Your Provider",
            items: [
                { href: "https://res.cloudinary.com/dirscuuhp/image/upload/A_Guide_for_Patients_by_Inner_Balance_kismuv.pdf", text: "Vaginal delivery", target: "_blank" },
                { href: "https://res.cloudinary.com/dirscuuhp/image/upload/Endometrial_Monitoring_by_Inner_Balance_ehngnh.pdf", text: "Endometrial monitoring", target: "_blank" },
                { href: "https://res.cloudinary.com/dirscuuhp/image/upload/Compounded_HRT_by_Inner_Balance_vmnhv6.pdf", text: "Compounding standards", target: "_blank" },
                { href: "https://res.cloudinary.com/dirscuuhp/image/upload/Lab_Interpretation_by_Inner_Balance_zzxigu.pdf", text: "Lab interpretation", variantText: "lab interpretation", target: "_blank" },
            ]
        },
    ]
];

export const footerSocialLinks = [
    {
        href: "https://www.instagram.com/innerbalancemd/",
        icon: <InstagramIcon width={32} height={32} />,
        title: "Inner Balance on Instagram",
    },
    {
        href: "https://www.facebook.com/Inner-Balance-61556388119053",
        icon: <FaceBookIcon width={32} height={32} />,
        title: "Inner Balance on Facebook",
    },
    {
        href: "https://www.youtube.com/channel/UCc-UcYfw7zzBqGrLgG8NdlA",
        icon: <YouTubeIcon width={32} height={15} className="pl-1" />,
        title: "Inner Balance on YouTube",
    },
    {
        href: "https://www.tiktok.com/@sarahdaccarettmd",
        icon: <TikTokIcon width={32} height={20} />,
        title: "Inner Balance on TikTok",
    },
];

export const footerLegalLinks = [
    {
        label: "Terms & Consent",
        href: "/p/terms-of-use",
    },
    {
        label: "Privacy Policy",
        href: "/p/privacy-policy",
    },
];
